"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReconciliationException = void 0;
const tslib_1 = require("tslib");
const ErrorCode_1 = (0, tslib_1.__importDefault)(require("./ErrorCode"));
class ReconciliationException extends Error {
    constructor() {
        super(`Fail to reconcile transaction, try to increase extra count or check the transaction`);
        this.code = ErrorCode_1.default.ReconciliationFailed;
    }
}
exports.ReconciliationException = ReconciliationException;
exports.default = {
    ReconciliationException,
};
//# sourceMappingURL=transaction.js.map